import { render } from "./InfoMessageEditDialog.vue?vue&type=template&id=777b0e56"
import script from "./InfoMessageEditDialog.vue?vue&type=script&lang=js"
export * from "./InfoMessageEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__